// src/components/approval/SignTable_doc_creator.jsx
import React, { useEffect, useState } from "react";
import { getDocSignatureInfo } from "../../api/papers";

/**
 * 문서 작성자 사인 표시 전용
 * - dns 기준
 * - 유저 API 사용 ❌
 */
export default function SignTableDocCreator({ dns }) {
  const [creator, setCreator] = useState(null);

  useEffect(() => {
    if (!dns) return;

    const load = async () => {
      try {
        const res = await getDocSignatureInfo(dns);
        setCreator(res?.data || null);
      } catch (e) {
        console.error("creator sign load error", e);
      }
    };

    load();
  }, [dns]);

  if (!creator) return null;

  return (
    <div className="flex justify-end">
      <table
        className="border mt-4 text-[12px] text-center border-black"
        style={{ width: "120px", tableLayout: "fixed" }}
      >
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-black h-[28px]">작성자</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border border-black relative h-[36px]">
              <span
                style={{
                  fontSize: "11px",
                  position: "absolute",
                  left: "6px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  whiteSpace: "nowrap",
                }}
              >
                {creator.name || "-"}
              </span>

              {creator.sign && (
                <img
                  src={creator.sign}
                  alt="sign"
                  style={{
                    position: "absolute",
                    right: "6px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    height: "70px",
                    maxWidth: "60px",
                    objectFit: "contain",
                  }}
                />
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
